import Keycloak from 'keycloak-js';
export var keycloak = new Keycloak({
    url: "".concat(process.env.SMARTPASS_LOGIN_URL),
    realm: "".concat(process.env.SMARTPASS_LOGIN_REALM),
    clientId: "".concat(process.env.SMARTPASS_LOGIN_CLIENT_ID),
});
